<template>
  <v-layout row wrap>
    <v-flex xs12 px-4 py-2>
      <v-form ref="form" v-model="formValid">
        <v-text-field v-model="analyteName" label="Input an Analyte Name" placeholder="Chloride (Cl)-Dissolved"
          :rules="analyteNameRules">
        </v-text-field>
        <v-combobox v-model="unitGroup" :items="commonUnitGroups" label="Select a Unit Group or specify one"
          :rules="unitGroupRules">
        </v-combobox>
      </v-form>
    </v-flex>
    <v-flex xs12 pb-3>
      <v-alert :type="formValid ? 'success' : 'info'" :value="hasInput" outline transition="slide-y-transition"
        style="padding: 8px">
        <template v-if="formValid">
          EnviroData Analyte Name: <span class="font-weight-bold font-italic">{{envirodataAnalyteName}}</span>
        </template>
        <template v-else>
          Please complete all form fields
        </template>
      </v-alert>
    </v-flex>
    <v-flex xs12>
      <v-btn color="warning" small @click="reset">Reset</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    data() {
      return {
        analyteName: '',
        analyteNameRules: [v => !!v || 'Analyte name cannot be blank'],
        unitGroup: '',
        unitGroupRules: [v => !!v || 'Unit group cannot be blank'],
        formValid: true,
        commonUnitGroups: [
          'Concentration (liquid)',
          'Concentration (solid)',
          'Mass',
          'PH',
          'Temperature',
          'Volume',
          'Percentage',
          'Weight Percentage',
          'Volume to Volume (percentage)',
          'Time',
          'Mass Per Area',
        ],
      }
    },
    computed: {
      hasInput() {
        return (this.analyteName != null && this.analyteName != '') || (this.unitGroup != null && this.unitGroup != '')
      },
      envirodataAnalyteName() {
        return `${this.analyteName}_${this.unitGroup}`
      },
      bottomMessage() {
        const analyteNameMessage = ''
        const incompleteFormMessage = 'Please complete all form fields'
        return this.formValid ? analyteNameMessage : incompleteFormMessage
      },
    },
    methods: {
      reset() {
        this.analyteName = ''
        this.unitGroup = ''
        this.$refs.form.resetValidation()
      },
    },
  }

</script>
